import { UPDATE_USER, type UserActionTypes, type UserType } from "../Actions/UserActions";

export interface UserState {
    user: false | UserType;
}

const DEFAULT_STATE: UserState = {
    user: false,
};

/**
 * Developer Layout Reducer function
 * @param state
 * @param action
 * @constructor
 */
export default function UserReducer(
    state: UserState,
    action: UserActionTypes
): UserState {
    if(typeof state === "undefined") {
        return DEFAULT_STATE;
    }

    switch(action.type) {
        case UPDATE_USER:
            return {
                ...state,
                user: action.user,
            };
        default:
            return state;
    }
}
